import SphSpinner from './Spinner.vue';

export { SphSpinner };
export default SphSpinner;
